import Render from '@Views/components/popin/layout/popin-component.html'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Render
@Component({})
export class PopinComponent extends Vue {
    
    @Prop() options: any
}